import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";

enum EndpointRoutes {
    GET_PILOT_FLIGHT_HOURS_STATISTIC = "stat/pilots/get",
}

@Injectable({
    providedIn: "root",
})
export class StatisticPilotHoursService {
    constructor(private _http: HttpClient) {}

    public getStatisticData(orgId: string, date: string) {
        let params = new HttpParams();
        params = params.append("organizationId", orgId);
        params = params.append("date", date);
        console.log(params);
        return this._http.get<any[]>(environment.serverUrl + EndpointRoutes.GET_PILOT_FLIGHT_HOURS_STATISTIC, { params: params }).pipe(
            map((responseData) => {
                return responseData;
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }
}
